module.exports = __webpack_public_path__ + "static/media/comment.739eb9e1.svg";